export default [
  { value: "none", label: "Selecionar" },
  { value: "money", label: "Dinheiro" },
  { value: "cheque", label: "Cheque" },
  { value: "credit_card", label: "Cartão de Crédito" },
  { value: "debit_card", label: "Cartão de Débito" },
  { value: "store_credit", label: "Crédito Loja" },
  { value: "alimentation_ticket", label: "Vale Alimentação" },
  { value: "meal_ticket", label: "Vale Refeição" },
  { value: "gift_ticket", label: "Vale Presente" },
  { value: "fuel_ticket", label: "Vale Combustível" },
  { value: "bank_slip", label: "Boleto Bancário" },
  { value: "others", label: "Outros" }
];



// WEBPACK FOOTER //
// ./src/core/enum/payment-others.enum.js